module.exports = __webpack_public_path__ + "img/3_newModelWorker_gh.fb9c16b5.png";